<template>
	<div class="config-admin">
		<div v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.7)">
			<!-- 头部：返回永远可用 -->
			<div class="header">
				<button class="back-btn" @click="goBack">
					<i class="el-icon-back"></i> 返回
				</button>
				<span class="title-text">{{ classInfo.courseName }}</span>
			</div>

			<div class="check-bar">
				<label><input v-model="show.bottomMenu" type="checkbox" disabled>底部导航菜单</label>
				<label><input v-model="show.chat" type="checkbox">聊天页面配置</label>
				<label><input v-model="show.upload" type="checkbox" :disabled="vimSave">上传评价配置</label>
				<label><input v-model="show.experiment" type="checkbox" :disabled="vimSave">实验模拟器配置</label>
				<label><input v-model="show.htmlfile" type="checkbox" :disabled="vimSave">网页文件</label>
			</div>
			<div class="config-wrap" style="position:relative;" v-if="islogin">
				<div class="config-scroll-box">
					<BottomMenuConfig v-if="show.bottomMenu" v-model="config.bottomMenu" :vimSave="vimSave" />
					<ChatConfig :modelList="modelList" :keyList="keyList" v-if="show.chat" v-model="config.chat"
						:vimSave="vimSave" />
					<UploadConfig :modelList="modelList" :keyList="keyList" v-if="show.upload" v-model="config.upload"
						:vimSave="vimSave" />
					<ExperimentConfig v-if="show.experiment" v-model="config.experiment" :vimSave="vimSave" />
					<HtmlFileVue v-if="show.htmlfile" :courseClassId="this.classInfo.id" v-model="config.htmlFile"
						:vimSave="vimSave"></HtmlFileVue>

					<div class="save-box">
						<button @click="saveConfig" class="save-btn" :disabled="saving||vimSave">
							<span v-if="saving"><i class="el-icon-loading"></i> 保存中...</span>
							<span v-else>💾 保存</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import BottomMenuConfig from './PaneList/BottomMenuConfig.vue'
	import ChatConfig from './PaneList/ChatConfig.vue'
	import UploadConfig from './PaneList/UploadConfig.vue'
	import ExperimentConfig from './PaneList/ExperimentConfig.vue'
	import HtmlFileVue from './PaneList/HtmlFileVue.vue'
	import {
		uploadAllIcons,
		HtmlToOss
	} from '@/js/img.js'
	import {
		bottomMenu,
		defaultConfigs
	} from "@/js/calssComponets.js"
	export default {
		components: {
			BottomMenuConfig,
			ChatConfig,
			UploadConfig,
			ExperimentConfig,
			HtmlFileVue
		},
		props: {},
		data() {
			return {
				loading: false,
				saving: false,
				show: {
					bottomMenu: true,
					chat: false,
					upload: false,
					experiment: false,
					htmlfile: false,
				},
				query: {},
				config: {},
				modelList: [],
				keyList: [],
				defaultlist: {},
				classInfo: {},
				vimSave: false,
				islogin: false,
				finalConfig: {},
			}
		},
		watch: {
			show: {
				handler(onval) {},
				immediate: true,
				deep: true,
			},
		},
		created() {
			this.classInfo = this.$route.query.classInfo
			if (this.$route.query.vimSave) {
				this.vimSave = this.$route.query.vimSave ? true : false
			}
			this.defaultlist = defaultConfigs()
			this.config = defaultConfigs()
			this.loadConfig()
		},
		methods: {
			goBack() {
				console.log(localStorage.getItem('userType'))
				// return 
				if (localStorage.getItem('userType') == 1) {
					this.$router.push({
						path: '/admin/dashboard',
					})
				}
				if (localStorage.getItem('userType') == 2) {
					this.$router.push({
						path: '/teacher/schoolModelManagement',
						query: {
							activeTab: 'schoolStandardCourseManagement' // 字符串/数字都可以
						}
					})
				}
			},
			mergeConfig(userConfig, defaultlist) {
				// 新增：用户配置为空，直接返回完整默认配置
				if (userConfig === null || userConfig === undefined) {
					// 浅拷贝防止外部修改defaultlist源对象
					return JSON.parse(JSON.stringify(defaultlist))
				}

				const merged = {}

				for (const key in defaultlist) {
					if (Array.isArray(defaultlist[key])) {
						merged[key] = userConfig[key] && Array.isArray(userConfig[key]) ? userConfig[key] : defaultlist[
							key]
					} else if (typeof defaultlist[key] === 'object' && defaultlist[key] !== null) {
						merged[key] = this.mergeConfig(userConfig[key], defaultlist[key])
					} else {
						merged[key] = userConfig[key] !== undefined ? userConfig[key] : defaultlist[key]
					}
				}
				for (const key in userConfig) {
					if (!(key in defaultlist)) {
						merged[key] = userConfig[key]
					}
				}

				return merged
			},
			// 合并show配置：后端有show则覆盖本地默认show
			mergeShow(userShow) {
				if (!userShow) return;
				for (let k in this.show) {
					if (userShow[k] !== undefined) {
						this.show[k] = userShow[k]
					}
				}
			},
			async tomodelList() {
				try {
					const res = await this.API.get(this.API.admin.getStandardModelSimple, {
						authType: 0
					})
					this.modelList = res.data.data || []
				} catch (error) {
					this.modelList = []
				}
			},
			async tokeyList() {
				try {
					const res = await this.API.get(this.API.admin.getModelKeySimple, {
						pageNum: 1,
						pageSize: 100,
						keyName: '',
						modelTypeId: null
					})
					this.keyList = res.data.data || []
				} catch (error) {
					this.keyList = []
				}
			},
			async loadConfig() {
				this.loading = true
				await this.tomodelList()
				await this.tokeyList()
				try {
					const courseId = this.classInfo.id
					const res = await this.API.get(this.API.admin.getCourseConfig + courseId)

					if (res?.data?.data) {
						let userConfigs = res.data.data
						let userConfig = JSON.parse(userConfigs)

						// 新增：加载后端存储的show显示配置
						if (userConfig.show) {
							this.mergeShow(userConfig.show)
						}

						//因为菜单问题同步一次最新的兜底
						if (userConfig.bottomMenu) {
							let bottom = bottomMenu()
							bottom = bottom.map(v => {
								if (userConfig.bottomMenu.filter(a => a.key == v.key).length > 0) {
									v = userConfig.bottomMenu.filter(a => a.key == v.key)[0]
								}
								return {
									...v
								}
							})
							userConfig.bottomMenu = bottom
						}
						this.config = this.mergeConfig(userConfig, this.defaultlist)
					} else {

						this.config = this.defaultlist

					}

				} catch (err) {

					this.config = this.defaultlist
				} finally {

					this.loading = false
					this.islogin = true
				}
			},
			checkEmptyFields(obj) {

				if (obj === null || obj === undefined) {
					return true;
				}
				if (typeof obj === 'string') {
					return obj.trim() === '';
				}
				if (Array.isArray(obj)) {
					for (let item of obj) {
						if (this.checkEmptyFields(item)) {
							console.log('item',item)
							return true;
						}
					}
					return false;
				}
				if (typeof obj === 'object' && obj !== null) {
					for (let key in obj) {

						if (obj.hasOwnProperty(key)) {
							if (key === 'keyList') continue;
							
							if(key==='chatFily'&&obj[key]?.length==0)return true
							// 这里只做校验，不修改finalConfig，移到saveConfig里预处理
							if (this.checkEmptyFields(obj[key])) {
								//
								console.log('key',key)
								return true;
							}
						}
					}
					return false;
				}
				return false;
			},

			async saveConfig() {
				if (this.saving) return
				//先判断是否有功能选中其一
				var issaving = this.show.chat ? this.show.chat : this.show.upload ? this.show.upload : this.show
					.htmlfile ? this.show.htmlfile : false
				if (!issaving) return this.$message.success('对话、作品评价、网页模拟必须选中一项！')

				this.saving = true
				// 深拷贝基础配置
				this.finalConfig = JSON.parse(JSON.stringify(this.config))
				// 【核心改动1】把当前页面show勾选状态存入待提交配置
				this.finalConfig.show = JSON.parse(JSON.stringify(this.show))

				let finalConfig = this.finalConfig
				let bottomMenu = this.finalConfig.bottomMenu
				var arr = {}

				if (!finalConfig.show.chat) {
					bottomMenu = bottomMenu.filter(v => v.key != 'chat')
					
					delete finalConfig.chat
				}else{
					if(finalConfig.chat.followUpList.filter(v=>v=='').length==3){
						delete finalConfig.chat.followUpList
					}else{
						finalConfig.chat.followUpList=finalConfig.chat.followUpList.filter(v=>v!=''&&v!=undefined)
					}
				}
				if (!finalConfig.show.upload) {
					bottomMenu = bottomMenu.filter(v => v.key != 'upload')
					bottomMenu = bottomMenu.filter(v => v.key != 'classworkshow')
					bottomMenu = bottomMenu.filter(v => v.key != 'workshow')
					delete finalConfig.upload
				}
				if (!finalConfig.show.experiment) {
					bottomMenu = bottomMenu.filter(v => v.key != 'experiment')
					delete finalConfig.experiment
				}
				console.log('finalConfig',finalConfig)
				if (!finalConfig.show.htmlfile) {
					bottomMenu = bottomMenu.filter(v => v.key != 'htmlfile')
					delete finalConfig.htmlFile
				}
				arr = finalConfig
				arr.bottomMenu = bottomMenu

				let istrue = await this.checkEmptyFields(arr)
				if (istrue) {
					this.saving = false
					this.$message.error('信息未填写完整')
					return
				}
				try {
					let finalConfigs = this.finalConfig
					console.log('finalConfig含show', finalConfigs)
					const courseId = this.classInfo.id
					finalConfigs = await uploadAllIcons(finalConfigs, courseId)
					if (!courseId) {
						this.$message.error('未获取到课程ID')
						return
					}
					const saveRes = await this.API.put(this.API.admin.putCourseConfig + courseId, finalConfigs)
					if (saveRes.data.code === 200) {
						this.$message.success('✅ 配置保存成功！')
						setTimeout(() => {
							this.goBack()
						}, 500)
					} else {
						const msg = saveRes.data.msg || '保存失败'
						this.$message.error('保存失败：' + msg)
					}
				} catch (err) {
					console.error('保存失败：', err)
					this.$message.error('❌ 保存失败')
				} finally {
					this.saving = false
				}
			},
		}
	}
</script>

<style scoped>
	.config-admin {
		width: 100%;
		background: #f7f8fa;
		padding: 20px;
		box-sizing: border-box;
	}

	.header {
		font-size: 22px;
		font-weight: bold;
		text-align: center;
		padding: 16px;
		background: #81c784;
		color: #fff;
		border-radius: 12px;
		margin-bottom: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	.back-btn {
		position: absolute;
		left: 16px;
		background: rgba(255, 255, 255, 0.2);
		border: 1px solid rgba(255, 255, 255, 0.3);
		color: #fff;
		padding: 8px 16px;
		border-radius: 6px;
		cursor: pointer;
		font-size: 14px;
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.back-btn:hover {
		background: rgba(255, 255, 255, 0.3);
	}

	.title-text {
		flex: 1;
	}

	.check-bar {
		background: #fff;
		border-radius: 12px;
		padding: 12px 16px;
		margin-bottom: 16px;
		display: flex;
		gap: 18px;
		flex-wrap: wrap;
	}

	.check-bar label {
		display: flex;
		align-items: center;
		gap: 5px;
		cursor: pointer;
		font-size: 14px;
	}

	.config-wrap {
		max-width: 1000px;
		margin: 0 auto;
	}

	.save-box {
		text-align: center;
		margin-top: 20px;
		padding-bottom: 30px;
	}

	.save-btn {
		background: #4CAF50;
		color: #fff;
		border: none;
		padding: 12px 30px;
		border-radius: 8px;
		font-size: 16px;
		cursor: pointer;
	}

	.config-scroll-box {
		max-height: calc(100vh - 220px);
		overflow-y: auto;
		padding-right: 6px;
	}
</style>